import { render, staticRenderFns } from "./Step4Component.vue?vue&type=template&id=054ad1ec&scoped=true&"
import script from "./Step4Component.vue?vue&type=script&lang=js&"
export * from "./Step4Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054ad1ec",
  null
  
)

export default component.exports